import React from 'react';

import { Typography, Button } from '@mui/material';

import { ReactComponent as EditTextIcon } from '../../../../common/assets/icons/edit_text_icon.svg';

type Props = {
  isDisabled: boolean;
  onClick: () => void;
};

const EditTextButton: React.FC<Props> = ({ isDisabled, onClick }) => {
  return (
    <Button
      disabled={isDisabled}
      onClick={onClick}
      variant='outlined'
      startIcon={<EditTextIcon />}
      color='darkBlue'
      sx={{
        borderRadius: '40px',
        height: '40px',
        padding: '0 16px',
      }}
    >
      <Typography>Edit</Typography>
    </Button>
  );
};

export default EditTextButton;
